import { FC } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import MuiCardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import { Column } from 'further-ui/components/Layout';
import { KybRequest } from 'further-types/lp/kyb';
import { kybRequestLabels } from 'further-ui/labels';

const defaultKybRequests = [
  KybRequest.EntityConstitutionalDocuments,
  KybRequest.RegistryExtract,
  KybRequest.EntityGroupOwnershipDiagram,
] as const;

const defaultKybRequestType = {
  [KybRequest.EntityConstitutionalDocuments]: 'Required file upload request',
  [KybRequest.RegistryExtract]: 'Required file upload request',
  [KybRequest.EntityGroupOwnershipDiagram]: 'Voluntary file upload request',
};

const CardContent = styled(MuiCardContent)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
  '&:last-child': {
    paddingBottom: theme.spacing(theme.spacingSizes.sm),
  },
}));

type Props = {
  description: string;
  inputType: string;
};

const DefaultKybRequest: FC<Props> = ({ description, inputType }) => (
  <Card variant="outlined">
    <CardContent>
      <Column spacing="sm">
        <Typography variant="h6">{description}</Typography>
        <Typography variant="body2" fontStyle="italic">
          {inputType}
        </Typography>
      </Column>
    </CardContent>
  </Card>
);

const DefaultKybRequests: FC = () => (
  <Column spacing="lg">
    {defaultKybRequests.map((request) => (
      <DefaultKybRequest
        key={request}
        description={kybRequestLabels[request].description}
        inputType={defaultKybRequestType[request]}
      />
    ))}
  </Column>
);

export default DefaultKybRequests;
